<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <v-row>
          <v-col cols="8">
            <v-text-field
              data-cy="FormRevenueLine-name"
              filled
              :label="$$t('name')"
              v-model="localRevenueLine.name"
            />
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              auto-select-first
              data-cy="FormRevenueLine-bankAccountId"
              filled
              :label="$$t('bankAccountId')"
              :items="bankAccounts"
              item-text="name"
              item-value="id"
              v-model="localRevenueLine.bankAccountId"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-autocomplete
              auto-select-first
              data-cy="FormRevenueLine-nonRecurringIncomeAccountId"
              filled
              :label="$$t('nonRecurringIncomeAccountId')"
              :items="incomeAccounts"
              item-text="name"
              item-value="id"
              v-model="localRevenueLine.nonRecurringIncomeAccountId"
            />
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              auto-select-first
              data-cy="FormRevenueLine-nonRecurringExpenseAccountId"
              filled
              :label="$$t('nonRecurringExpenseAccountId')"
              :items="expenseAccounts"
              item-text="name"
              item-value="id"
              v-model="localRevenueLine.nonRecurringExpenseAccountId"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-autocomplete
              data-cy="FormRevenueLine-recurringIncomeAccountId"
              filled
              :label="$$t('recurringIncomeAccountId')"
              :items="incomeAccounts"
              item-text="name"
              item-value="id"
              v-model="localRevenueLine.recurringIncomeAccountId"
            />
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              data-cy="FormRevenueLine-recurringExpenseAccountId"
              filled
              :label="$$t('recurringExpenseAccountId')"
              :items="expenseAccounts"
              item-text="name"
              item-value="id"
              v-model="localRevenueLine.recurringExpenseAccountId"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              type="number"
              data-cy="FormRevenueLine-estimatedDaysAfterAcceptence"
              filled
              :label="$$t('estimatedDaysAfterAcceptence')"
              v-model="localRevenueLine.estimatedDaysAfterAcceptence"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              data-cy="FormRevenueLine-contractCode"
              filled
              :label="$$t('contractCode')"
              v-model="localRevenueLine.contractCode"
              :rules="[rules.alphaNumeric]"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <TemplateUpload />
          </v-col>
        </v-row>
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormRevenueLine-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormRevenueLine-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import TemplateUpload from '~src/components/TemplateUpload.vue';
import accounts from '../mixins/accounts';

export default {
  name: 'FormRevenueLine',
  module: 'Contract',
  mixins: [accounts, loading],
  components: {
    TemplateUpload,
  },
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    RevenueLine: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localRevenueLine
      */
      localRevenueLine: {},
      rules: {
        alphaNumeric: (value) => {
          if (/^[a-zA-Z0-9]{1,6}$/.test(value)) {
            return true;
          }
          return 'The currency code must be between 1 and 6 characters long and contain only alpha-numeric characters';
        },
      },
    };
  },
  watch: {
    RevenueLine() {
      this.localRevenueLine = this.RevenueLine;
    },
  },
  created() {
    this.localRevenueLine = this.RevenueLine;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localRevenueLine);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>
